
import { Game } from '@/types/Interfaces';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class GameListItem extends Vue {
    @Prop() private game!: Game;
}
